<template>
	<div class="row">
		<div class="col-12">
			<div>
				<card title="Users" :subTitle="'Total: '+(users.length).toString()">
					<template slot="command">
						<p-button icon round type="link" :loading="loading" @click.native.prevent="loadUsers"><i class="ti-reload"></i></p-button>
						<router-link to="users/new"><p-button round class="btn btn-success">Add</p-button></router-link>
					</template>
					<div class="row mb-3">
						<div class="col-xl-4">
							<b-form-input autocomplete='off' v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-table responsive striped hover :filterIncludedFields="filterOn" :filter="filter" :per-page="num_for_page" :current-page="currentPage" 
							:items="users" :fields="columns" :busy='loading' @filtered="onFiltered" show-empty>
								<template v-slot:table-busy>
									<loader :loading="loading"></loader>
								</template>
								<template v-slot:cell(username)="row">
									<router-link :to="'users/'+row.item.id_user">{{row.item.username}}</router-link>
								</template>
								<template v-slot:cell(active)="row">
									<i v-if="row.item.active===1" class="ti-check"></i>
									<i v-if="row.item.active===0" class="ti-close"></i>
								</template>
							</b-table>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="num_for_page" align="right"></b-pagination>
						</div>
					</div>
				</card>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data(){
		return {
			loading:false,
			users:[],
			columns: [
				{
					key: "id_user",
					label: "#",
				},
				{
					key: "username",
					label: "Username"
				},
				{
					key:"active",
					label:"Active"
				},
				{
					key:"role",
					label:"Role",
					formatter:function(val){
						return val.description
					}
				}
			],
			filter:null,
			currentPage:1,
			num_for_page:5,
			totalRows:1,
			filterOn: []
		}
	},
	methods:{
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		async loadUsers(){
			this.loading = true;
			let result = await this.$api.get('user?join=role');
			this.users = result.data;
			this.loading = false;
		}
	},
	async beforeMount(){
		await this.loadUsers();
		this.totalRows = this.users.length;
	}
}
</script>

<style>
</style>
